module.exports = __webpack_public_path__ + "static/media/pinRed.aa1617bc.svg";